#import "../fragments/sales-automation-stageset.graphql"

mutation DeleteClosedLeadSlackMessage(
    $closedLeadSlackMessage: DeleteClosedLeadSlackMessageInputFieldInput!
) {
    deleteClosedLeadSlackMessage(input: {closedLeadSlackMessage: $closedLeadSlackMessage}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
